import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { inject, Injectable } from "@angular/core";
import { map } from "rxjs";


@Injectable({
    providedIn: "root"
}) export class ResponsiveService {
    private bpo = inject(BreakpointObserver);

    isMobileEvent = this.bpo.observe([
            Breakpoints.Handset
        ]).pipe(
            map(state => state.matches)
        );

    isMobileLandscapeEvent = this.bpo.observe([
            Breakpoints.HandsetLandscape
        ]).pipe(
            map(state => state.matches)
        );
}
